module.exports = __webpack_public_path__ + "a0bd90318ff964d49e24720ed2235dd1.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/close.svg
// module id = 91
// module chunks = 0